import client from "./axiosConfig";

export const startDay = (data) => {
  const config = {
    url: "/tracker/day/",
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const EndDay = (id, data) => {
  const config = {
    url: `/tracker/day/${id}/`,
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
}

export const MarkComplete = (id, data) => {
  const config = {
    url: `/tracker/task/${id}/`,
    method: "PATCH",
    data,
  };
  const response  = client(config);
  return response;
}
